<template>
    <modal name="upload-photos" @before-open="beforeOpen" @before-close="beforeClose" :classes="[
        'v--modal',
        'error-modal',
        'upload-photos',
        hasBugs && 'has-bugs',
    ]" :width="730" :height="'auto'" :scrollable="true" :adaptive="true">
        <div class="modal-title">
            {{ $t("upload.loading") }} {{ isVideo ? $t("albums.video") : $t("albums.photo") }}
        </div>
        <div class="modal-close" @click="close"></div>
        <div class="modal-body">
            <ul v-if="!errors.has('image')" :class="isVideo ? 'upload-videos-list' : 'upload-photos-list'">
                <li v-for="(_, index) in instanceArr.length" :key="index" :style="{
                    'background-image':
                        !isVideo && instanceArr[index].image
                            ? 'url(' + instanceArr[index].image + ')'
                            : '',
                }" :class="isVideo ? 'video-preview' : 'image-preview'">
                    <div v-if="isVideo" class="upload-photos-name">
                        <span>{{ instanceArr[index].name }}</span>
                    </div>
                    <div class="delete-image" @click="deleteImage('image', 'image', instanceArr, false, index)"
                        v-if="instanceArr[index].image || instanceArr[index].video"></div>
                    <textarea v-model="instanceArr[index].description" type="text" class="textarea"
                        :placeholder="isVideo ? $t('upload.videoDescription') : $t('upload.photoDescription')"></textarea>
                </li>
            </ul>

            <div v-show="instanceArr.length == 0 || errors.has('image') || instanceLoader
                " class="upload-photos-upload">
                <div v-if="isVideo" class="modal-subtitle">
                    {{ $t("upload.downloadVideoFormat") }}
                    <span v-for="(ext, i) in videoExt" :key="ext">
                        {{ ext.toUpperCase() }}<span v-if="i < videoExt.length - 2">,</span>
                        <span v-else-if="i < videoExt.length - 1">
                            {{ $t("upload.or") }}
                        </span>
                    </span>
                    {{ $t("upload.upTo150") }} <br />
                    {{ $t("upload.videosLongerShortened") }}
                </div>
                <div v-else class="modal-subtitle">
                    {{ $t("upload.youUploadImage") }}
                </div>
                <input v-if="isVideo" type="file" accept="video/mp4,video/x-m4v,video/*" id="image" name="image"
                    v-validate.persist="{
                        required: true,
                        size: maxVideoSize,
                        ext: videoExt,
                    }" data-vv-as="file" :multiple="true" @change="
    addImage($event, 'video', instanceArr, checkErrors, maxVideoSize)
    " class="input-hidden" />
                <input v-else type="file" accept="image/*" id="image" name="image" v-validate.persist="{
                    required: true,
                    size: maxImageSize,
                    ext: ['jpeg', 'jpg', 'png', 'gif'],
                    mindimensions: myPuzzles ? [600, 600] : [1, 1],
                }" data-vv-as="file" :multiple="album.album_type != 2" @change="
    addImage($event, 'image', instanceArr, checkErrors, maxImageSize)
    " class="input-hidden" />
                <label v-if="!instanceLoader" for="image" class="button-secondary">{{ $t("upload.selectFiles") }}</label>
                <button v-else type="button" class="button button-loader"></button>
            </div>

            <div v-if="!hasAlbum && !albumsLoader" class="multiselect-wrapper">
                <multiselect v-model="album" :options="localAlbums" @select="checkAlbumOnSelect" track-by="id" label="title"
                    :placeholder="$t('upload.selectAlbum')" :searchable="false" selectLabel="" deselectLabel=""
                    :option-height="26" :maxHeight="225" :allowEmpty="false" openDirection="bottom" id="album" name="album"
                    v-validate.persist="{ isPuzzle: [album, 600, 600] }">
                    <template slot="option" slot-scope="props">
                        <!-- <span :ref="'element' + props.option.id">{{
                            props.option.title
                        }}</span> -->
                        <span :ref="'element' + props.option.id">
                            {{
                                props.option.title === 'Общий'
                                ? $t('albums.general')
                                : props.option.title
                            }}
                        </span>
                    </template>
                </multiselect>
                <label v-if="!album" for="album" class="mobile-placeholder">
                    {{ $t("upload.selectAlbum") }}
                </label>
            </div>

            <div v-if="instanceArr.length && !errors.has('image') && !instanceLoader" class="buttons-row">
                <button @click="resetInstances(), close()" type="button" class="button-secondary">
                    {{ $t("stories.cancel") }}
                </button>
                <button @click="create" v-if="!loader" class="button">
                    {{ $t("settings.save") }}
                </button>
                <button v-if="loader" type="button" class="button button-loader"></button>
            </div>
        </div>
    </modal>
</template>

<script>
import { uploadImage } from "@/mixins/uploadImage";
import { localizeValidation } from "@/mixins/localizeValidation";
import { observeListEnd } from "@/mixins/observeListEnd";
import { checkScroll } from "@/mixins/checkScroll";
import Multiselect from "@/components/Blocks/Multiselect";

export default {
    name: "UploadPhotos",
    components: {
        Multiselect,
    },
    mixins: [uploadImage, localizeValidation, observeListEnd, checkScroll],
    data() {
        return {
            hasBugs: false,
            loader: false,
            instanceLoader: false,
            instanceArr: [],
            hasAlbum: false,
            album: "",
            albumId: null,
            moreIndex: 0,
            observer: null,
            albumsLoader: false,
            myAlbums: false,
            myPuzzles: false,
            isVideo: false,
            maxVideoSize: 153600,
            maxImageSize: 10240,
            videoExt: ["avi", "mpg", "mp4", "mkv", "webm", "mov", "wmv", "m4v"],
        };
    },
    computed: {
        albums() {
            return this.$store.getters[
                this.getAlbumMethod() +
                "/fetch" +
                this.getMethod(true, "", false) +
                "Albums"
            ];
        },
        albumsIsEmpty() {
            return this.$store.getters[this.getAlbumMethod() + "/isEmpty"];
        },
        nextAlbums() {
            return this.$store.getters[
                this.getAlbumMethod() +
                "/fetchNext" +
                this.getMethod(true, "", false) +
                "Albums"
            ];
        },
        newAlbum() {
            return this.$store.getters[
                this.getAlbumMethod() +
                "/fetchNew" +
                this.getMethod(true, "", false) +
                "Album"
            ];
        },
        instancesErrors() {
            return this.$store.getters[this.getMethod() + "/errors"];
        },
        localAlbums() {
            let albs = this.albums ? this.albums.slice(0) : [];
            albs.push({
                id: "new",
                title: this.$t("upload.newAlbom"),
                album_type: "new",
            });
            return albs;
        },
    },
    watch: {
        newAlbum(from, to) {
            if (from != to) {
                this.setNewAlbum();
            }
        },
    },
    methods: {
        getMethod(capitalize = false, method = "", isPlural = true) {
            let str = this.isVideo ? "video" : "photo";
            if (capitalize) str = str.charAt(0).toUpperCase() + str.slice(1);
            if (isPlural) str += "s";
            return str + method;
        },
        getAlbumMethod(method = "") {
            return (this.isVideo ? "videoAlbums" : "albums") + method;
        },
        beforeOpen(event) {
            this.checkScroll();
            this.localizeValidation();
            if (event.params) {
                this.isVideo = event.params.isVideo || false;
                if (event.params.puzzles) {
                    this.myPuzzles = true;
                    this.hasAlbum = true;
                } else {
                    this.myPuzzles = false;
                }
                if (event.params.id) {
                    this.albumId = event.params.id;
                } else {
                    this.albumId = null;
                }
                if (event.params.album) {
                    this.album = event.params.album;
                    this.hasAlbum = true;
                }
                if (event.params.myAlbums) {
                    this.albumsLoader = true;
                    this.getAlbums();
                } else {
                    this.setObserver();
                }
            } else {
                this.albumId = null;
                this.myPuzzles = false;
                this.isVideo = false;
            }

            let self = this;
            const minDimensionsRule = {
                getMessage(field, [width, height], data) {
                    return (
                        (data && data.message) ||
                        `as ${width}*${height} qw`
                    );
                },
                validate(files, [width, height]) {
                    const validateImage = (file, width, height) => {
                        const URL = window.URL || window.webkitURL;
                        return new Promise((resolve) => {
                            const image = new Image();
                            image.onerror = () => resolve({ valid: false });
                            image.onload = () =>
                                resolve({
                                    valid:
                                        image.width >= Number(width) &&
                                        image.height >= Number(height),
                                });

                            image.src = URL.createObjectURL(file);
                        });
                    };
                    const list = [];
                    for (let i = 0; i < files.length; i++) {
                        if (!/\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(files[i].name)) {
                            return false;
                        }
                        list.push(files[i]);
                    }
                    return Promise.all(
                        list.map((file) => validateImage(file, width, height))
                    );
                },
            };

            this.$validator.extend("mindimensions", minDimensionsRule);

            const isPuzzleRule = {
                getMessage(field, [album, width, height], data) {
                    return (
                        (data && data.message) ||
                        `2121 ${width}*${height} 12`
                    );
                },
                validate(value, [album, width, height]) {
                    if (self.myPuzzles && self.instanceArr.length) {
                        const validateImage = (file, width, height) => {
                            return new Promise((resolve) => {
                                const image = new Image();
                                image.onerror = () => resolve({ valid: false });
                                image.onload = () =>
                                    resolve({
                                        valid:
                                            image.width >= Number(width) &&
                                            image.height >= Number(height),
                                    });

                                image.src = file.image;
                            });
                        };
                        return Promise.all(
                            self.instanceArr.map((file) => validateImage(file, width, height))
                        );
                    } else {
                        return { valid: true };
                    }
                },
            };
            this.$validator.extend("isPuzzle", isPuzzleRule);
        },
        beforeClose() {
            this.resetInstances();
            this.checkRemoveScroll();
        },
        getAlbums() {
            this.$store
                .dispatch(this.getAlbumMethod("/getMy"))
                .then(() => {
                    this.albumsLoader = false;
                    this.setObserver();
                })
                .catch(() => {
                    this.albumsLoader = false;
                });
        },
        setObserver() {
            if (!this.hasAlbum) {
                this.observer = new IntersectionObserver(
                    (entries) => {
                        if (entries[0].isIntersecting === true) {
                            this.showMore();
                        }
                    },
                    { threshold: [0] }
                );

                this.updateMoreIndex();
                this.observeListEnd("element");
            }
        },
        checkAlbumOnSelect(selectedOption, id) {
            //console.log('test');
            if (selectedOption.album_type == "new") {
                this.$modal.show("create-album", { isVideo: this.isVideo });
                setTimeout(() => {
                    this.album = "";
                }, 100);
            }

            if (selectedOption.album_type == 2 && this.instanceArr.length) {
                this.checkErrors();
            }
        },
        checkErrors() {
            // this.instanceLoader = true;
            let self = this;
            setTimeout(function () {
                self.$validator
                    .validateAll()
                    .then((valid) => {
                        // this.instanceLoader = false;
                        if (valid) {
                            if (self.myPuzzles && self.instanceArr.length) {
                                self.$modal.show("crop-puzzle", {
                                    image: self.instanceArr[0].image,
                                    album: self.album.id,
                                    create: true,
                                });
                                self.resetInstances();
                                self.$modal.hide("upload-photos");
                            }
                        } else {
                            self.$modal.show("dialog", {
                                title: this.$t("albumEdit.warning"),
                                text: self.errors.first(self.errors.items[0].field),
                                buttons: [
                                    {
                                        title: this.$t("albumEdit.ok"),
                                        handler: () => {
                                            if (self.errors.has("image")) {
                                                self.errors.clear();
                                                self.$validator.reset();
                                                if (
                                                    document.getElementById("image") &&
                                                    document.getElementById("image").length
                                                ) {
                                                    document.getElementById("image").value = "";
                                                }
                                                self.instanceArr = [];
                                            }
                                            self.$modal.hide("dialog");
                                        },
                                    },
                                ],
                            });
                        }
                    })
                    .catch(() => {
                        // this.instanceLoader = false;
                    });
            }, 300);
        },
        setNewAlbum() {
            this.album = this.newAlbum;
        },
        create() {
            let self = this;
            this.$validator.validateAll().then((valid) => {
                if (valid && this.instanceArr.length) {
                    this.loader = true;
                    if (this.album || this.albumId) {
                        let currentAlbum = this.album ? this.album.id : this.albumId;
                        for (let i in this.instanceArr) {
                            this.instanceArr[i].album = currentAlbum;
                        }
                    }
                    this.$store
                        .dispatch(this.getMethod(false, "/create"), this.instanceArr)
                        .then(() => {
                            this.resetInstances();
                            this.$modal.hide("upload-photos");
                            this.loader = false;
                        })
                        .catch(() => {
                            if (typeof this.instancesErrors === "object") {
                                let text = "";
                                for (let i in this.instancesErrors) {
                                    for (let key in this.instancesErrors[i]) {
                                        text += this.instancesErrors[i][key][0];
                                        text += "<br>";
                                    }
                                }
                                this.$modal.show("dialog", {
                                    title: this.$t("albumEdit.warning"),
                                    text: text,
                                    buttons: [
                                        {
                                            title: this.$t("albumEdit.ok"),
                                        },
                                    ],
                                });
                            }
                            this.loader = false;
                        });
                }
            });
        },
        resetInstances() {
            this.errors.clear();
            this.$validator.reset();
            if (
                document.getElementById("image") &&
                document.getElementById("image").length
            ) {
                document.getElementById("image").value = "";
            }
            this.instanceArr = [];
            this.hasAlbum = false;
            this.album = "";
        },
        updateMoreIndex() {
            this.moreIndex = this.localAlbums[this.localAlbums.length - 2].id;
        },
        showMore() {
            if (this.nextAlbums) {
                this.$store.dispatch(this.getAlbumMethod("/getNext")).then(() => {
                    this.observeListEnd("element", false, true, true);
                });
            } else {
                this.observeListEnd("element", false, true);
            }
        },
        close() {
            this.$modal.hide("upload-photos");
        },
    },
};
</script>

<style lang="scss">
@import "~@/assets/styles/components/_validation";
@import "~@/assets/styles/layout/_upload-photos";
</style>
